module.exports = __webpack_public_path__ + "img/resourcesFolder.be19240b.svg";